module.exports = __webpack_public_path__ + "static/media/PPT-prev.b8ed6ade.svg";